/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState, Runner } from '@modules/ui-types'

import { getRunner } from '@/reducers/runners'
import { deleteRunnerRequest } from '@/reducers/asyncRequests/registry'

import { deleteRunnerAndRedirect } from '../../../actions/runners'

import DeleteHost from './DeleteHost'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

interface StateProps {
  runner?: Runner
  deleteRunnerRequest: AsyncRequestState
}

interface DispatchProps {
  deleteRunnerAndRedirect: () => Promise<any>
}

type ConsumerProps = { regionId: string; hostId: string }

const mapStateToProps = (state: ReduxState, { regionId, hostId }: ConsumerProps): StateProps => ({
  runner: getRunner(state, regionId, hostId),
  deleteRunnerRequest: deleteRunnerRequest(state, regionId, hostId),
})

const mapDispatchToProps = (dispatch: ThunkDispatch, { regionId, hostId }: ConsumerProps) => ({
  deleteRunnerAndRedirect: () => dispatch(deleteRunnerAndRedirect(regionId, hostId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteHost)
